<script setup>
import { computed } from 'vue';
import { REPLY_EDITOR_MODES } from './constants';

const props = defineProps({
  mode: {
    type: String,
    default: REPLY_EDITOR_MODES.REPLY,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  isReplyRestricted: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['toggleMode']);

const isPrivate = computed(() => {
  if (props.isReplyRestricted) return true;
  return props.mode === REPLY_EDITOR_MODES.NOTE;
});
</script>

<template>
  <div
    class="flex gap-0"
    :class="{ 'opacity-50 pointer-events-none': disabled || isReplyRestricted }"
  >
    <div
      class="px-[10px] py-[3px] text-[11px] font-semibold cursor-pointer border-b-2 transition-all duration-150"
      :class="
        !isPrivate
          ? 'text-n-brand border-n-brand'
          : 'text-n-stone-300 border-transparent hover:text-n-stone-500'
      "
      @click="$emit('toggleMode')"
    >
      {{ $t('CONVERSATION.REPLYBOX.REPLY') }}
    </div>
    <div
      class="px-[10px] py-[3px] text-[11px] font-semibold cursor-pointer border-b-2 transition-all duration-150"
      :class="
        isPrivate
          ? 'text-n-brand border-n-brand'
          : 'text-n-stone-300 border-transparent hover:text-n-stone-500'
      "
      @click="$emit('toggleMode')"
    >
      {{ $t('CONVERSATION.REPLYBOX.PRIVATE_NOTE') }}
    </div>
  </div>
</template>
